<script setup lang="ts">
import PartAppLogo from '@parts/part-app-logo.vue';
import ButtonNavigationLink from '@buttons/button-navigation-link.vue';
import {useI18n} from 'vue-i18n';
import {useAuthApi} from "@store/api/authApi";

const { logout } = useAuthApi().methods;
const {t} = useI18n();

defineProps({
	list: {
		type: Array,
		default: () => []
	}
});
</script>
<template>
	<div class="part-app-sidebar">
		<part-app-logo
			class="part-app-sidebar__logo"
			font="font-18-pro-medium"
		/>
		<ul v-if="list.length > 0" class="part-app-sidebar__menu">
			<li
				v-for="(item, index) in list" :key="index"
				class="part-app-sidebar__menu-item"
			>
				<button-navigation-link
					v-bind="item"
					class="part-app-sidebar__menu-link"
				/>
			</li>
		</ul>
		<div class="part-app-sidebar__bottom">
			<button-navigation-link
				:icon="{ name: 'logout', viewBox: '0 0 18 18' }"
				:title="t('common.buttons.logout')"
				class="part-app-sidebar__logout"
				@click.prevent="logout"
			/>
		</div>
	</div>
</template>

<style lang="scss">
.part-app-sidebar {
	background: rgba(var(--color-active-rgb), 0.04);
	width: var(--sidebar-width);
	border-radius: 2.4rem;
	padding: 2.4rem 2rem;
	display: flex;
	flex-direction: column;
	gap: 2rem;

	&__logo {
		padding: 1.6rem 1.2rem;
		gap: 1.6rem;
		--logo-width: 4.8rem;
	}

	&__menu {
		display: flex;
		flex-direction: column;
		gap: 0.6rem;
		&:hover {
			.router-link-active:not(:hover) {
				background: transparent;
				color: var(--color-text);
				box-shadow: none;
			}
		}
	}

	&__menu-item {
		display: block;
	}
	&__menu-link {
		width: 100%;
	}

	&__logout {
		width: 100%;
	}

	&__bottom {
		margin-top: auto;
	}
}
</style>
